import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useOrderPackage from '../../../hooks/useOrderPackage';
import AddonSheetBuilder from '../../PackageBuilders/AddonSheets';
import routes from '../../../routes';
import { useCustomer } from '../../../contexts/CustomerContext';

export default function IndividualPrintEdit() {
  const { orderPackageId } = useParams();
  const { data: orderPackage } = useOrderPackage(orderPackageId);
  const { customer, setCustomer } = useCustomer();
  const history = useHistory();

  const onSave = () => {
    setCustomer({ ...customer, currentOrderPackage: orderPackage });

    history.push(routes.confirm(orderPackage.id));
  };

  if (!orderPackage) return null;

  return <AddonSheetBuilder orderPackageId={orderPackageId} onSave={onSave} />;
}
